import type { Grouping } from '@bugbug/core/types/groups';
import type { CurrentTestGroup } from '@bugbug/core/types/tests';
import { useAppSelector } from '~/modules/store';
import { selectAllGroupInstancesById, selectGroup } from '~/modules/tests/tests.selectors';
import { selectDraggedStepGroupId } from '~/modules/uiState/uiState.selectors';

export const useDifferentInstanceOfDraggedStepGroup = (groupId: Grouping['id']) => {
  const group = useAppSelector(selectGroup(false, groupId)) as CurrentTestGroup | undefined;
  const otherInstancesOfThisGroup = useAppSelector(selectAllGroupInstancesById(group?.id));
  const draggedStepGroupId = useAppSelector(selectDraggedStepGroupId);
  const isDifferentInstanceOfDraggedStepGroup =
    draggedStepGroupId !== groupId &&
    otherInstancesOfThisGroup.map(({ id }) => id).includes(draggedStepGroupId || '');

  return !!group?.isComponent && isDifferentInstanceOfDraggedStepGroup;
};
